import { render, staticRenderFns } from "./ViewCarto.vue?vue&type=template&id=472fb4b4"
import script from "./ViewCarto.vue?vue&type=script&lang=js"
export * from "./ViewCarto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports